<template>
    <div class="cloud-performance-card">
        <CommonComponentsProductsCloudPerformanceCard
            v-for="(performanceItem, itemIndex) in performanceList"
            :id="`cloud-performance-grid-${itemIndex}`"
            :key="itemIndex"
            :performance-item="performanceItem"
            :index="itemIndex"
            class="card-item"
        />
    </div>
</template>

<script setup lang="ts">
    import png1 from '@assets/imgs/Products/Cloud/Performance/Frame1.png';
    import png2 from '@assets/imgs/Products/Cloud/Performance/Frame2.png';
    import png3 from '@assets/imgs/Products/Cloud/Performance/Frame3.png';
    import png4 from '@assets/imgs/Products/Cloud/Performance/Frame4.png';

    const performanceList = reactive<Array<FunctionTitle>>([
        {
            png: png1,
            title: 'global_cloud_performance_title_0',
            subTitle: 'global_cloud_performance_subTitle_0',
        },
        {
            png: png2,
            title: 'global_cloud_performance_title_1',
            subTitle: 'global_cloud_performance_subTitle_1',
        },
        {
            png: png3,
            title: 'global_cloud_performance_title_2',
            subTitle: 'global_cloud_performance_subTitle_2',
        },
        {
            png: png4,
            title: 'global_cloud_performance_title_3',
            subTitle: 'global_cloud_performance_subTitle_3',
        },
    ]);
    //
</script>

<style lang="less" scoped>
    .cloud-performance-card {
        display: flex;
        justify-content: center;
        gap: .convert(@flex-gap-lg) [ @vw];
        margin-bottom: .convert(200px) [ @vw];
        flex-wrap: wrap;
        @media (max-width: @screen-mobile-width) {
            gap: .convert(16px) [ @vw-mobile]; //
            display: grid;
            grid-template-columns: 1fr 1fr;
            grid-template-rows: 1fr 1fr;
        }
    }
</style>
